import { shape, string, bool, number } from 'prop-types';

export const catalogProductType = shape({
  id: string.isRequired,
  name: string.isRequired,
  catalogId: string.isRequired,
  productCode: string.isRequired,
  returnable: bool.isRequired,
  createdBy: string.isRequired,
  createTimestamp: string.isRequired
});

export const seasonType = shape({
  name: string.isRequired,
  sequenceNumber: number.isRequired
});
